"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Str = void 0;
const toTitleCase_1 = __importDefault(require("./toTitleCase"));
exports.Str = {
    /**
     * Generates a random string with the specified length.
     *
     * @see https://www.30secondsofcode.org/js/s/random-alphanumeric/
     */
    random: (length = 6) => {
        let s = '';
        Array.from({ length }).some(() => {
            s += Math.random().toString(36).slice(2);
            return s.length >= length;
        });
        return s.slice(0, length);
    },
    toTitleCase: toTitleCase_1.default,
};
exports.default = exports.Str;
